<template>
    <div class="vx-col w-full mb-base">
        <vx-card title="Payroll Computation Overview">
            <template slot="actions">
                <feather-icon icon="HelpCircleIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
            </template>

            <!-- CHART -->
            <template slot="no-body">
                <div class="mt-10">
                    <vue-apex-charts type="radialBar" height="240" :options="analyticsData.goalOverviewRadialBar.chartOptions" :series="percentage"  />
                </div>
            </template>

            <!-- DATA -->
            <div class="flex justify-between text-center mt-6" slot="no-body-bottom">
                <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
                    <p class="mt-4">Completed</p>
                    <p class="mb-4 text-3xl font-semibold">{{ this.counter }}</p>
                </div>
                <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
                    <p class="mt-4">Total Employees</p>
                    <p class="mb-4 text-3xl font-semibold">{{ this.getAllLogHours.length }}</p>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import VueApexCharts from 'vue-apexcharts'
import analyticsData from '../../ui-elements/card/analyticsData.js'

import axios from '@/axios.js'
export default {
    props: {
        createPayroll: {
            type: Object,
            required: false
        },
        isValidate5: {
            type: Boolean,
            required: false
        },
    },
    data() {
        return {
            counter         :0,
            percentage      :[0],

            analyticsData,

            
        }
    },
    computed: {
        getAllLogHours() {
            return this.$store.state.payroll.getAllLogHours
        },
        getTenantsSchedule() {
            return this.$store.state.tenants.tenantsSchedule
        }
    },
    watch: {
        isValidate5(value) {
            if(value)
            this.onCalculatePayroll()    
        }
    },
    methods: {
        onCalculatePayroll() {
           
            this.percentage = [0]
            this.counter = 0
            
            const payload = {
                        payrollId: this.createPayroll.createPayrollId,
                        paymentModeId: this.createPayroll.paymentModeId,
                        periodId: this.createPayroll.periodId,
                        monthId: this.createPayroll.monthName,
                        cutOffStartDate: this.createPayroll.cutOffStartDate,
                        cutOffEndDate: this.createPayroll.cutOffEndDate,
                        calendarYear: this.createPayroll.calendarYear,
                        tenantsId: this.$store.state.AppActiveUser.tenantsId,
                        roundOff: this.getTenantsSchedule.roundOff,
                        processedBy: this.$store.state.AppActiveUser.uid
            }
            axios.get('/api/payroll/processpayroll', { params: {
                    payrollId: payload.payrollId,
                    paymentModeId: payload.paymentModeId,
                    periodId: payload.periodId,
                    monthId: payload.monthId,
                    cutOffStartDate: payload.cutOffStartDate,
                    cutOffEndDate: payload.cutOffEndDate,
                    calendarYear: payload.calendarYear,
                    tenantsId: payload.tenantsId,
                    roundOff: payload.roundOff,
                    userId: payload.processedBy
                }})
                        .then(res=> {
                            this.$vs.loading()
                            setInterval(()=>{
                                if(this.counter == 100){
                                    clearInterval();
                                    this.$vs.loading.close()
                                    // this.$alert('Calculate Successful', 'Done', 'success')
                                }
                                else{
                                    this.counter+=1;
                                    this.percentage = [this.counter]
                                }
                            }, 40);
                        })
                        .catch((err) => { 
                            this.$vs.loading.close()
                            console.log(err)
                        })
                // let counter = 0;

        },
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        VueApexCharts,
    }
    
}
</script>